import { useTenderDeadline } from "../../../../hooks/useTenderDeadline";
import React from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../common.module.scss";
import { TenderDeadlineText } from "../../../shared/TenderDeadlineText/TenderDeadlineText";
import ThreeDots from "../../../shared/Loading/ThreeDots";

const TenderDeadlineInfo = ({ item }) => {
  const { isExpired: isTenderExpiredByServer, isReady: isTenderTimeReady } = useTenderDeadline(item?.tenderDateEnd, { inclusive: true });
  const { t } = useTranslation();

  const isExpired = item?.tenderDateEnd
    ? isTenderExpiredByServer
    : false;
  const isAuction = item?.assignmentMethod === "Auction";

  return (
    <div className={cn(style.cargo_wrapper)}>
      {item?.tenderDateEnd ? (
        <>
          <div
            className={cn(style.cargo_title, style.orders_title)}
            style={{
              justifyContent: "space-between",
              ...(!isExpired ? { borderBottom: "0.5px solid #E6E0EC" } : { padding: "0" }),
            }}
          >
            <span className={style.suggested_infoLabel} style={{ fontSize: "16px" }}>
              {t(
                isAuction
                  ? "orderInfoExpeditor.suggestPrice.auctionDeadline"
                  : "orderInfoExpeditor.suggestPrice.tenderDeadline",
              )}
            </span>
            <span className={cn(style.suggested_infoValue, style.suggested_deadline)}>
              <TenderDeadlineText date={item.tenderDateEnd} />
            </span>
          </div>
          {isTenderTimeReady && !isExpired && (
            <div className={style.suggested_noOffers}>
              <span className={style.suggested_noOffersText}>{t("orderInfo.suggestPrice.noOffersYet")}</span>
              <ThreeDots />
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default TenderDeadlineInfo;
